/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MicroClose = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 10L4.99998 3L2.87866 5.12132L9.87866 12.1213L2.99998 19L5.1213 21.1213L12 14.2426L18.8318 21.0744L20.9531 18.9531L14.1213 12.1213L21.0744 5.16823L18.9531 3.04691L12 10Z"
                        fill={color}
                    />
                </svg>
        );
    };
